






















import { Component, Vue, Emit, Prop } from 'vue-property-decorator';

@Component
export default class CommonModalHeader extends Vue {
  @Prop(Boolean) public isAddFileModal!: boolean;
  @Prop(String) public modalHeaderTitle!: string;
  @Prop(String) public modalMode!: string;
  @Prop(String) private modalHeaderWidthValue!: string;
  @Prop(String) public modalHeaderWidthElementId!: string;

  private mounted() {
    window.addEventListener('resize', this.updateWidth)
  }

  private beforeDestroy() {
    window.removeEventListener('resize', this.updateWidth)
  }

  private updateWidth(): void {
    const element = document.querySelector(this.modalHeaderWidthElementId);
    if (element) {
      this.modalHeaderWidthValue = `${element.clientWidth}px`;
    }
  }

  @Emit('closeModal')
  private closeModal(): void {
    this.isAddFileModal = false;
    // メンバー情報詳細画面を消した時にtooltipElementも消す
    const tooltipElement = document.getElementById('chartjs-tooltip');
    if (document.getElementById('tooltipElement') == null && tooltipElement !== null) {
      tooltipElement.style.opacity = '0';
    }
  }

  private modalIcon(): string | void {
    if (this.modalMode === 'delete') {
      return;
    } else if (this.modalMode === 'add') {
      return 'mdi-plus';
    } else if (this.modalMode === 'move') {
      return 'mdi-swap-horizontal';
    }
  }

  private modalType(): string | void {
    if (this.modalMode === 'delete') {
      return 'error';
    } else if (this.modalMode === 'add') {
      return 'info';
    } else if (this.modalMode === 'move') {
      return 'success';
    }
  }

  private modalCloseButtonColor(): string | void {
    if (this.modalMode === 'delete') {
      return '#fa5f7e';
    } else if (this.modalMode === 'add') {
      return '#4384f3';
    } else if (this.modalMode === 'move') {
      return 'green';
    }
  }
}
